// START IMPORTS
import {
  PdfUpgradeBrandWrapper,
  PdfModalsState,
} from '@ltvco/refresh-lib/payments';
import { Box, styled } from '@ltvco/refresh-lib/theme';
import { useScreenSize } from '@ltvco/refresh-lib/utils';
import { useAccount } from '@ltvco/refresh-lib/v1';
import { useBannerLogic } from '@ltvco/refresh-lib/v2';
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

import { useFirstRecordSearch } from 'routes/utils/useFirstRecordSearch';
// END IMPORTS

// START STYLED_COMPONENTS
const AppWrapper = styled('div')(({ theme }) => ({
  margin: '70px 8px 0 8px',
  backgroundColor: theme.palette.background.default,
  paddingBottom: theme.spacing(0.25),
  [theme.breakpoints.up('md')]: {
    margin: '55px 0 0 0',
  },
}));
// END STYLED_COMPONENTS

export function AppContainer({
  children,
}: {
  children: React.ReactNode | React.ReactNode[];
}) {
  // START HOOKS_AND_QUERIES
  const location = useLocation();
  const { isDesktop } = useScreenSize();
  const { isUserInTest } = useBannerLogic();
  const { data: account } = useAccount(true);
  const { showFirstTimePDFModal } = useFirstRecordSearch();
  // END HOOKS_AND_QUERIES

  // START STATE_MANAGEMENT
  const [pdfModalState, setPdfModalState] = useState<PdfModalsState>(
    PdfModalsState.None
  );
  // END STATE_MANAGEMENT

  // START DERIVED_DATA_AND_UTILS
  const isOnReportView = location.pathname.includes('/report/');
  const wrapperId = isUserInTest && isDesktop ? 'app-container' : undefined;
  // END DERIVED_DATA_AND_UTILS

  // START EFFECTS
  useEffect(() => {
    if (account?.account?.user_info?.password_delayed) {
      window.open(
        'https://www.numberguru.com/account/password_update',
        '_self'
      );
    }
  }, [account?.account?.user_info?.password_delayed]);

  useEffect(() => {
    if (showFirstTimePDFModal) {
      setPdfModalState(PdfModalsState.AddonCheckoutModal);
    }
  }, [showFirstTimePDFModal]);
  // END EFFECTS

  // START RENDER
  return (
    <AppWrapper
      id={wrapperId}
      sx={{
        marginX: isOnReportView ? 0 : null,
        marginTop: isOnReportView ? '70px' : '80px',
      }}
    >
      <Box>{children}</Box>
      <PdfUpgradeBrandWrapper
        modalState={pdfModalState}
        setModalState={setPdfModalState}
      />
    </AppWrapper>
  );
  // END RENDER
}
